import { Plus } from 'lucide-react'
interface PackagesHeaderProps {
    onShowForm: () => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    selectedService: string;
    setSelectedService: (service: string) => void;
}

export default function PackagesHeader({ onShowForm, activeTab, setActiveTab, selectedService, setSelectedService }: PackagesHeaderProps) {

    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <div className="w-full flex flex-col items-start justify-start">
            <div className="w-[82%] flex items-center justify-between gap-x-6">
                <nav className="flex text-white text-xs">
                    <ul className="flex gap-x-6">
                        <li
                            className={`cursor-pointer ${activeTab === 'All' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('All')}
                        >
                            All
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'Active' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('Active')}
                        >
                            Active
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'Inactive' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('Inactive')}
                        >
                            Inactive
                        </li>
                    </ul>
                </nav>

                <button
                    onClick={onShowForm}
                    className="w-fit items-center flex text-xs text-gray-400 bg-none border border-gray-400 p-1 rounded-md hover:bg-gray-700 transition-colors duration-200"
                >
                    <Plus />

                    Create Package
                </button>
            </div>

            <div className="flex items-center gap-x-4 my-3">
                <div className="relative">
                    <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700" value={selectedService} onChange={(e) => setSelectedService(e.target.value)}>
                        <option value="All">All Services</option>
                        <option value="kanema">kanema</option>
                        <option value="mingoli">mingoli</option>
                        <option value="katswiri">katswiri</option>
                        <option value="nkhani">nkhani</option>
                    </select>
                </div>

                <div className="relative">
                    <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                        <option value="">All</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="pending">Pending</option>
                    </select>
                </div>

                <div className="relative">
                    <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                        <option value="">All</option>
                        <option value="">Most Used</option>
                        <option value="">Least Used</option>
                    </select>
                </div>
            </div>

        </div>
    )
}